import { ComplexAnimatedModal } from "../../../../../ui/modal/ComplexAnimatedModal";
import FacilityCard from "../../facilityCard";
import styles from "./styles.module.scss";

interface FacilityCardModal {
  id: number;
  opened: boolean;
  offsetY: number;
  onClose: (value: boolean) => void;
}

const FacilityCardModal = ({
  id,
  opened,
  offsetY,
  onClose,
}: FacilityCardModal) => {
  
  return (
    <ComplexAnimatedModal
      opened={opened}
      onClose={() => onClose(false)}
      offsetY={offsetY}
    >
      <div className={styles.facilityCardModal}>
        <div className={styles.facilityCardModal__container}>
          <FacilityCard id={id} />
        </div>
      </div>
    </ComplexAnimatedModal>
  );
};

export default FacilityCardModal;
